// extracted by mini-css-extract-plugin
export default {"arrow":"arrow-538d","alert":"alert-e8ef","link":"link-e27f"};